export { NavBar, TabBar, SafeArea, Form, Input, Button, Dialog, TextArea, DatePicker, Selector, Slider, Stepper, Switch, } from 'antd-mobile';
const bizCssPrefix = 'h5-antd-mobile';
export { bizCssPrefix };
